<!--
 * @Description: 提交订单 暂存订单 取消
 * @Autor: txp
 * @Date: 2021-04-14 11:32:59 == 'Y'? '暂存订单':'订单信息确认'
-->
<template>
  <div class="submitholdorder">
    <el-dialog
      :showClose="false"
      :title="titles === 'Y' ? '暂存订单' : '提交订单'"
      :visible.sync="orderBoolean"
      :lock-scroll="false"
      :close-on-click-modal="false"
      width="70%"
      top="10vh"
    >
      <div
        class="shopsettle_order_box"
        v-loading="orderLoading"
        element-loading-spinner="el-icon-loading"
      >
        <!-- 这里显示是点击取消得 -->
        <div v-if="titles == 'Z'">
          点击“确定”则取消该订单，“返回”则返回订单确认页面，继续结算订单。
        </div>
        <!-- 这里是暂存订单，或者是订单结算 -->
        <div v-else>
          <!-- 基本信息 -->
          <div class="container-info">
            <h3>基础信息</h3>
            <div class="mtb10  flex info-style">
              <p>
                <span class=" C333">客户名称：</span>
                <span class="C151515">{{ receivingInfo.customerName }}</span>
              </p>
              <p>
                <span class=" C333">所属集团：</span>
                <span class="C151515">{{ receivingInfo.companyName }}</span>
              </p>
              <p>
                <span class=" C333">配送方式：</span>
                <span class="C151515">{{ receivingInfo.pickTypeName }}</span>
              </p>
              <p>
                <span class=" C333">收货地址：</span>
                <span class="C151515">{{ receivingInfo.pickAdress }}</span>
              </p>
            </div>
            <div class="mtb10  flex info-style">
              <p>
                <span class=" C333">收货人电话：</span>
                <span class="C151515">{{ receivingInfo.contactPhone }}</span>
              </p>
              <p>
                <span class="C333">收件人：</span>
                <span class="C151515">{{ receivingInfo.contactName }}</span>
              </p>
              <p>
                <span class="C333">发票类型：</span>
                <span class="C151515">{{ receivingInfo.ext3Name }}</span>
              </p>
              <p>
                <span class="C333">供货方式：</span>
                <span class="C151515">{{ receivingInfo.ext1Name }}</span>
              </p>
            </div>
            <div class="mtb10  flex info-style">
              <p v-if="receivingInfo.pickType === '0'">
                <span class="C333">运输方式：</span>
                <span class="C151515">{{ receivingInfo.ext2Name }}</span>
              </p>
              <p v-if="receivingInfo.pickType === '1'">
                <span class="C333">提货人姓名：</span>
                <span class="C151515">{{ receivingInfo.ext4 }}</span>
              </p>
              <p v-if="receivingInfo.pickType === '1'">
                <span class="C333">身份证号：</span>
                <span class="C151515">{{ receivingInfo.ext5 }}</span>
              </p>
              <p v-if="receivingInfo.pickType === '1'">
                <span class="C333">车牌号：</span>
                <span class="C151515">{{ receivingInfo.ext6 }}</span>
              </p>
            </div>
            <!-- <div class="mtb20  flex info-style" v-if="receivingInfo.pickType === '1'">
             
            </div> -->
          </div>

          <div class="container-info">
            <!-- <h3>结算信息</h3> -->
            <div class="mtb10  flex info-style">
              <p>
                <span class=" C333">订单总金额（元）：</span>
                <span class="C151515">￥{{ orderInfo.amount || '0' }}</span>
              </p>
              <p>
                <span class=" C333">政策优惠金额（元）：</span>
                <span class="C151515">￥{{ orderInfo.promotionAmount || '0' }}</span>
              </p>
              <p>
                <span class=" C333">使用货补费用（元）：</span>
                <span class="C151515">￥{{ orderInfo.repAmount || '0' }}</span>
              </p>
              <p>
                <span class=" C333">返利及现金垫付抵扣金额（元）：</span>
                <span class="C151515">{{ orderInfo.discountAmount }}</span>
              </p>
            </div>
            <div class="mtb10  flex info-style">
              <p>
                <span class="C333">本单应付金额：</span>
                <span class="C151515">{{ orderInfo.actualAmount }}</span>
              </p>
              <p>
                <span class="C333">本单总重量（KG）：</span>
                <span class="C151515">{{ orderInfo.weightOfKilogram }}</span>
              </p>
              <p>
                <span class="C333">起运量（KG）：</span>
                <span class="C151515">{{ receivingInfo.startShipQuantity }}</span>
              </p>
              <p>
                <span class="C333">商品数量：</span>
                <span class="C151515">{{ orderInfo.productNum }}</span>
              </p>
            </div>
          </div>
          <!-- 订单金额 -->
          <!-- <div class="padding20 ft14 userInfo">
            <div class="flex">
              <p>
                <span class="C787878">订单总金额：</span>
                <span class="C000">￥{{ orderInfo.amount || '0' }}</span>
              </p>
              <p>
                <span class="C787878">政策优惠金额（元）：</span>
                <span class="C000">￥{{ orderInfo.promotionAmount || '0' }}</span>
              </p>
              <p>
                <span class="C787878">使用货补费用（元）：</span>
                <span class="C000">￥{{ orderInfo.repAmount || '0' }}</span>
              </p>
              <p>
                <span class="C787878">折扣可用余额（元）：</span>
                <span class="C000">￥{{ receivingInfo.usableAmount || '0' }}</span>
              </p>
            </div>
            <div class="flex mt10">
              <p>
                <span class="C787878">本单折扣可用金额：</span>
                <span class="C000">￥{{ orderInfo.maxDiscountAmount || '0' }}</span>
              </p>
              <p>
                <span class="C787878">使用费用：</span>
                <span class="C000">￥{{ orderInfo.discountAmount || '0' }}</span>
              </p>
              <p>
                <span class="C787878">本单实际支付（元）：</span>
                <span class="C000">￥{{ orderInfo.actualAmount || '0' }}</span>
              </p> -->
          <!-- <p><span class="C787878">本单应付金额：</span><span class="C000">￥{{moneyInfo.amount}}</span></p> -->
          <!-- </div>
          </div> -->
          <!-- 商品列表 -->
          <div class="mt20">
            <h3>商品信息</h3>
            <TableConent height="mini" class="mt20" :table_config="table_config" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer mt20 submitBTn">
          <!-- <el-button size="middle"
                     type="primary"
                     @click="holdOrder(titles)">查看详情</el-button> -->
          <el-button
            size="middle"
            type="primary"
            :loading="btnLoading"
            plain
            @click="holdOrder(true)"
          >
            确定
          </el-button>
          <el-button size="middle" @click="holdOrder(false)">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * @description: 订单结算 暂存  取消
 * @param {*}  OrderAdd 订单
 * @param {*}  TemporaryAdd 暂存订单
 * @return {*}
 * @author: txp
 */
import { Storage } from '@/utils/storage'
import { orderAdd, orderTemporary, orderEdit } from '@/api/api'
import TableConent from './TableConent'
import cals from '../js/cals.js'
import { getOrderCollect } from '@/api/api'
import { Loading } from 'element-ui'

export default {
  props: {
    receivingInfo: Object,
    orderBoolean: {
      type: Boolean,
      default: false
    },
    titles: {
      type: String,
      default: ''
    },
    moneyInfo: {
      type: Object,
      default: function() {
        return {}
      }
    },
    selectV: {
      type: Object,
      default: function() {
        return {}
      }
    },
    temporaryFlag: {
      type: String,
      default: 'N'
    },
    remarks: {
      type: String,
      default: ''
    },
    id: String,
    orderCode: String,
    discountAmount: String
  },
  components: {
    TableConent
  },
  data() {
    return {
      customerName: '',
      table_config: {
        thead: [
          { label: '商品编码', prop: 'productCode' },
          { label: '商品名称', prop: 'productName', width: '300px' },
          { label: '单价（元）', prop: 'ext27' },
          //  { label: '原单价（元）', prop: 'ext26' },
          { label: '订单数量', prop: 'productNum' },
          { label: '销售单位', prop: 'salesUnitName' },
          { label: '重量（KG）', prop: 'weightOfKilogram' },
          { label: '折前金额（元）', prop: 'amount' },
          { label: '政策优惠金额（元）', prop: 'ext21' },
          { label: '货补抵扣金额（元）', prop: 'ext22' },
          { label: '返利及现金垫付抵扣金额（元）', prop: 'ext23' },
          { label: '折后金额（元）', prop: 'ext26' }

          // { label: '规格', prop: 'spec' },
          // { label: '金额（元）', prop: 'amount' }
        ],
        checkbox: false, //是否显示多选
        table_data: [],
        isBorder: false //是否需要边框线
      },
      orderInfo: {
        discountAmount: '',
        amount: 0,
        promotionAmount: 0,
        repAmount: 0,
        usableAmount: 0,
        maxDiscountAmount: 0,
        actualAmount: 0,
        weightOfKilogram: 0
      },
      orderLoading: false,
      btnLoading: false
    }
  },
  created() {
    this.customerName = Storage.l.get('customerName')
    this.receivingInfo.customerName = Storage.l.get('customerName')
    this.getEndData()
  },
  methods: {
    // 获取结算信息
    getEndData() {
      const groupItemVos = cals.handleSubmitCal('submit')
      const params = {
        cusCode: Storage.l.get('customerCode'),
        discountAmount: this.discountAmount,
        fromType: 0,
        ext10: this.receivingInfo.ext10,
        groupItemVos
      }
      this.orderLoading = true
      getOrderCollect(params).then((res) => {
        if (res.success) {
          this.orderInfo = {
            discountAmount: res.result.discountAmount,
            amount: res.result.amount,
            promotionAmount: res.result.promotionAmount,
            repAmount: res.result.repAmount,
            usableAmount: res.result.usableAmount,
            maxDiscountAmount: res.result.maxDiscountAmount,
            actualAmount: res.result.actualAmount,
            weightOfKilogram: res.result.weightOfKilogram,
            productNum: res.result.productNum
          }
          this.table_config.table_data = res.result.orderDetailCollectVos
        }
        this.orderLoading = false
      }).catch(err=>{
         this.orderLoading = false
      })
    },
    holdOrder(type) {
      if (type) {
        this.submit()
      } else {
        this.$emit('SubmitholdOrders', false)
      }
      // if (type == "Y" || type == "N") {
      //   //暂存订单操作  提交订单
      //   this.orderconfirm(type);
      // } else if (type == "Z") {
      //   //取消 回到上一页
      //   window.history.back();
      // }
      // this.$emit("SubmitholdOrders", false);
    },
    // 提交表单
    async submit() {
      const groupItemVos = cals.handleSubmitCal('submit')
      const params = {
        ...this.receivingInfo,
        contactsName: this.receivingInfo.contactName,
        contactsPhone: this.receivingInfo.contactPhone,
        pickAdress: this.receivingInfo.pickAdress,
        temporaryFlag: this.receivingInfo.temporaryFlag,
        discountAmount: this.orderInfo.discountAmount,
        maxDiscountAmount: this.orderInfo.maxDiscountAmount,
        cusCode: this.receivingInfo.customerCode,
        cusName: this.receivingInfo.customerName,
        fromType: 0,
        id: this.id,
        type: this.receivingInfo.orderType,
        orderCode: this.orderCode,
        productNum: this.table_config.table_data.reduce((prev, cur) => prev + cur.productNum, 0),
        groupItemVos
      }
      if (this.titles === 'Y') {
        if (this.id) {
          this.btnLoading = true
          orderEdit(
            { ...params, processCode: 'order_approval' },
            { headers: { menuCode: 'CRM20210129000000857_1' } }
          )
            .then((res) => {
              this.btnLoading = false
              this.$message.success('操作成功')
              Storage.l.remove('orderList')
              this.$emit('SubmitholdOrders', false)
              this.$router.push({
                path: '/home/contentmain?type=first'
              })
            })
            .catch((error) => {
              this.btnLoading = false
            })
        } else {
          this.btnLoading = true
          orderTemporary(params)
            .then((res) => {
              this.btnLoading = false
              this.$message.success('操作成功')
              Storage.l.remove('orderList')
              this.$emit('SubmitholdOrders', false)
              this.$router.push({
                path: '/home/contentmain?type=first'
              })
            })
            .catch((error) => {
              this.btnLoading = false
            })
        }
        return false
      }
      this.btnLoading = true
      try {
        // if (this.id) {
        //   const res = await orderEdit(
        //     { ...params, processCode: "order_approval" },
        //     { headers: { menuCode: "CRM20210129000000857_1" } }
        //   );
        // } else {
        const res = await orderAdd(
          { ...params, processCode: 'order_approval' },
          { headers: { menuCode: 'CRM20210129000000857_1' } }
        )
        // }

        this.btnLoading = false
        this.$message.success('操作成功')
        Storage.l.remove('orderList')
        this.$emit('SubmitholdOrders', false)
        this.$router.push({
          path: '/home/contentmain?type=second'
        })
      } catch (e) {
        console.log(e)
        this.btnLoading = false
      }

      // request.post(path, params).then((res) => {
      //   if (res.success) {
      //     this.$message.success('操作成功');
      //     this.$emit('onClose');
      //     this.$emit('onGetList');
      //   }
      // });
    }
  }
}
</script>

<style lang="scss" scoped>
.mtb10 {
  margin-bottom: 10px;
}
.submitholdorder {
  .container-info {
    h3 {
      margin-bottom: 10px;
    }
    .info-style {
      font-size: 14px;
      color: #333333;
      p {
        width: 25%;
      }
    }
  }
  .shopsettle_order_box {
    padding: 0px 50px;
    .ulList li {
      background: #fafafa;
      border: 1px solid #d8d8d8;
      padding: 10px;
    }
    .userInfo {
      border: 1px solid #d8d8d8;
      border-radius: 4px;
      div {
        p {
          width: 25%;
        }
      }
    }
  }
  .submitBTn {
    text-align: center;
  }
  /deep/.el-dialog__header {
    padding: 10px 20px;
    background: #f3f3f3;
    color: #333333;
  }
  /deep/.el-button {
    width: 120px;
  }
}
</style>
